import React from 'react'
import { Control, Controller } from 'react-hook-form'

import { HouseSearchResultsFiltersSelector } from '../house-search-results-filters-selector/HouseSearchResultsFiltersSelector'

export interface IHouseSearchResultsFiltersControlledSelectorProps {
  control: Control<any, any>
  label: React.ReactNode
  name: string
  options: {
    label: string
    value: string
  }[]
}

export const HouseSearchResultsFiltersControlledSelector = ({
  control,
  label,
  name,
  options,
}: IHouseSearchResultsFiltersControlledSelectorProps) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => {
        return (
          <HouseSearchResultsFiltersSelector
            label={label}
            onSelect={(value) => {
              field.onChange(value)
            }}
            options={options}
          />
        )
      }}
    />
  )
}
